import { __rest } from '../../../../../../_virtual/_tslib.js';
import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { StyledDropdownMenu } from './DropdownMenu.styles.js';
import { NavbarContext } from './NavbarContext.js';
var DropdownMenu = React.forwardRef(function menu(props, ref) {
  // eslint-disable-next-line react/prop-types
  var children = props.children,
      isOpen = props.isOpen,
      maxWidth = props.maxWidth,
      width = props.width,
      _props$inNavbar = props.inNavbar,
      inNavbar = _props$inNavbar === void 0 ? false : _props$inNavbar,
      className = props.className,
      rest = __rest(props, ["children", "isOpen", "maxWidth", "width", "inNavbar", "className"]);

  var _useContext = useContext(NavbarContext),
      isDark = _useContext.isDark;

  var classNames = "helix-unified-nav__dropdown-menu ".concat(className ? className : '');

  if (typeof document === 'undefined') {
    return null;
  }

  return React.createElement(React.Fragment, null, createPortal(React.createElement(StyledDropdownMenu, Object.assign({
    ref: ref,
    isOpen: isOpen,
    maxWidth: maxWidth,
    width: width,
    isDark: isDark,
    inNavbar: inNavbar,
    className: classNames
  }, rest), React.createElement(React.Fragment, null, children)), document.body));
});
export { DropdownMenu as default };